// Services/WidgetService.js
import { Variables } from "../../../Variations/Variations";
import Cookies from "js-cookie";
import { withLoader } from "../../../Services/ApiClient";

const headers = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${Cookies.get("UserToken")}`,
});

const handle = async (res) => {
    if (!res.ok) {
      const errorText = await res.text();
      throw errorText || "Request failed";
    }
  
    // No content at all
    if (res.status === 204) return null;
  
    const text = await res.text();
  
    // Empty body but 200 OK
    if (!text) return null;
  
    // JSON body
    try {
      return JSON.parse(text);
    } catch {
      // Not JSON (string message, etc.)
      return text;
    }
  };
  

export const WidgetService = {
  getPaged: (page, pageSize, search = "") =>
    withLoader(
      fetch(
        `${Variables.API_URL}Widgets/GetWidgetsPaged?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
        { headers: headers() }
      ).then(handle)
    ),

  getById: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/GetWidget/${id}`, {
        headers: headers(),
      }).then(handle)
    ),

  create: (payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/AddWidget`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(payload),
      }).then(handle)
    ),

  update: (id, payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/UpdateWidget/${id}`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(payload),
      }).then(handle)
    ),

  togglePublish: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/TooglePublishWidget/${id}`, {
        method: "POST",
        headers: headers(),
      }).then(handle)
    ),

  // ---------- Categories ----------
  getCategories: () =>
    withLoader(
      fetch(`${Variables.API_URL}Category/GetCategories`).then(handle)
    ),

  getAssignedCategories: (widgetId) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/GetAssignedCategories/${widgetId}`, {
        headers: headers(),
      }).then(handle)
    ),

  assignCategories: (widgetId, categories) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/AssignCategoryToWidget/${widgetId}`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(
          categories.map(c => ({
            WidgetId: widgetId,
            CategoryId: c.CategoryId,
          }))
        ),
      }).then(handle)
    ),

  // ---------- Attributes ----------
  getAssignedAttributes: (widgetId) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/GetAssignedAttributeValues/${widgetId}`, {
        headers: headers(),
      }).then(handle)
    ),

  getUnAssignedAttributes: (widgetId) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/GetUnAssignedAttributeValues/${widgetId}`, {
        headers: headers(),
      }).then(handle)
    ),

  assignAttribute: (widgetId, attributeValueId) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/AssignAttributeValueToWidget`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({
          WidgetId: widgetId,
          AttributeValueId: attributeValueId,
        }),
      }).then(handle)
    ),

  unassignAttribute: (widgetId, attributeValueId) =>
    withLoader(
      fetch(`${Variables.API_URL}Widgets/UnassignAttributeValueToWidget`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({
          WidgetId: widgetId,
          AttributeValueId: attributeValueId,
        }),
      }).then(handle)
    ),
};
